import React, { useState } from "react";
import Countup from "react-countup"

const WhyChouse = () => {
    const [ytshow, setytshow] = useState(false);



    return (
        <>
            <div className="why-choose-section-four">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 m-auto">
                            <div className="heading-box text-center">
                                <span className="sub-title animate fadeInUp wow" data-wow-duration="1500ms">
                                    Why Choose Us
                                </span>
                                <h2 className="heading-title animate fadeInUp wow" data-wow-duration="1500ms" data-wow-delay="200ms">
                                    Our skills are the reasons why clients choose us
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-between gutter-y-30">
                        <div className="col-12">
                            <div className="why-choose-video-four">
                                <div className="why-choose-image-four"></div>
                                <button className="why-choose-play-btn" onClick={() => setytshow(true)}>
                                    <i className="fa-solid fa-play" />
                                </button>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="why-choose-left-four animate fadeInLeft wow" data-wow-duration="1500ms" data-wow-delay="200ms">
                                <p>
                                    <span className="counter">
                                        <Countup end={430} duration={6} />
                                    </span> <span>K</span>
                                </p>
                                <h5>Projects completed in the last 5 years</h5>
                            </div>
                        </div>
                        <div className="col-xl-5 col-lg-6">
                            <ul className="why-choose-list-four">
                                <li className="animate fadeInRight wow" data-wow-duration="1500ms" data-wow-delay="200ms">
                                    <div className="why-choose-order-list">
                                        <p>1</p>
                                    </div>
                                    <div className="why-choose-details-four">
                                        <h4>Projection Report Analysis</h4>
                                        <p className="lead">
                                            We guarantee to provide affordable business consulting solutions that help you reduce costs.
                                        </p>
                                    </div>
                                </li>
                                <li className="animate fadeInRight wow" data-wow-duration="1500ms" data-wow-delay="400ms">
                                    <div className="why-choose-order-list">
                                        <p>2</p>
                                    </div>
                                    <div className="why-choose-details-four">
                                        <h4>Consultation Solution</h4>
                                        <p className="lead">
                                            We stay up-to-date with the latest technology so you stay ahead of the competition.
                                        </p>
                                    </div>
                                </li>
                                <li className="animate fadeInRight wow" data-wow-duration="1500ms" data-wow-delay="600ms">
                                    <div className="why-choose-order-list">
                                        <p>3</p>
                                    </div>
                                    <div className="why-choose-details-four">
                                        <h4>Industry Expertise</h4>
                                        <p className="lead">
                                            We specialize in serving specific industries, such as healthcare, finance, or manufacturing.
                                        </p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* Video Modal */}
            {ytshow && (
                <>
                    <div className="YouTubePopUp-Wrap"
                        tabIndex={-1}
                        style={{ display: "block", opacity: 157 }}
                        aria-modal="true">
                        <div className="YouTubePopUp-Content">
                            <span className="YouTubePopUp-Close" onClick={() => setytshow(false)} />
                            <iframe
                                width={640}
                                height={360}
                                src="https://www.youtube.com/embed/rzfmZC3kg3M?autoplay=1"
                                allowFullScreen=""
                            />
                        </div>
                    </div>
                </>

            )}
        </>
    );
};

export default WhyChouse;